export const SoftwareIcon = ({ useOriginalColor }) => (
  <svg width="31" height="20" viewBox="0 0 31 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M28.8061 8.47887C29.7826 9.37398 29.7988 10.8425 28.8422 11.7588L22.3394 17.9881C21.3828 18.9045 19.8157 18.9217 18.8393 18.0266C17.8628 17.1315 17.8466 15.663 18.8032 14.7466L25.306 8.51734C26.2626 7.60098 27.8296 7.58376 28.8061 8.47887Z"
      fill="currentColor"
    />
    <path
      d="M28.9444 11.6417C29.8963 10.7242 29.8757 9.25868 28.8984 8.36832L22.2147 2.27913C21.2374 1.38876 19.6734 1.41074 18.7216 2.32822C17.7697 3.2457 17.7903 4.71125 18.7676 5.60161L25.4513 11.6908C26.4286 12.5812 27.9925 12.5592 28.9444 11.6417Z"
      fill="currentColor"
    />
    <path
      d="M1.76809 11.8375C0.791603 10.9424 0.775464 9.47395 1.73205 8.55759L8.23482 2.32829C9.19141 1.41194 10.7585 1.39472 11.735 2.28983C12.7115 3.18494 12.7276 4.65342 11.771 5.56977L5.26823 11.7991C4.31165 12.7154 2.74459 12.7326 1.76809 11.8375Z"
      fill="currentColor"
    />
    <path
      d="M1.72355 8.67274C0.771662 9.59022 0.792259 11.0558 1.76956 11.9461L8.45329 18.0353C9.43059 18.9257 10.9945 18.9037 11.9464 17.9862C12.8983 17.0688 12.8777 15.6032 11.9004 14.7128L5.21667 8.62365C4.23937 7.73329 2.67545 7.75526 1.72355 8.67274Z"
      fill="currentColor"
    />
  </svg>
);
